import React from "react";
import { ArrowRight } from "lucide-react";
import { CASE_STUDIES } from "../../data/transform";
import { useHomeCta } from "../../hooks/useHomeCta";
import { openAgent } from "../../utils/openAgent";

export const CaseStudies = () => (
  <section className="w-full" style={{ background: "#FAFBFC" }}>
    <div className="mx-auto max-w-[1440px] px-6 py-14 lg:px-[94px]">
      <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
        <div className="flex flex-col gap-[9px]">
          <p className="text-[12px] tracking-[3px] text-[#51627C]">REAL OUTCOMES. LASTING IMPACT.</p>
          <h2 className="text-[30px] font-normal text-[#06152B] sm:text-[38px]">Transformation in action.</h2>
        </div>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-7 md:grid-cols-2 lg:grid-cols-3">
        {CASE_STUDIES.map((c) => (
          <div key={c.tag} className="flex gap-[18px]">
            <img src={`/images/transform/${c.img}.png`} alt={c.tag} className="h-[186px] w-[156px] shrink-0 rounded-[11px] object-cover" />
            <div className="flex flex-1 flex-col gap-[10px] py-[9px]">
              <span className="w-fit rounded-full border border-[#DDE7F2] px-3 py-1 text-[10.6px] text-black">{c.tag}</span>
              <p className="text-[14.6px] leading-[19px] text-black">{c.title}</p>
              <div className="flex items-end gap-6">
                {c.stats.map((s) => (
                  <div key={s.value} className="flex flex-col">
                    <span className="text-[22px] font-bold leading-none text-black">{s.value}</span>
                    <span className="mt-1 text-[10px] text-[#51627C]">{s.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const TransformCta = () => {
  const goToHomeCta = useHomeCta();
  return (
    <section
      id="cta"
      className="relative w-full overflow-hidden flex items-center py-20 sm:py-24 lg:py-28"
      style={{ backgroundColor: "#000E1B", minHeight: 440 }}
    >
      {/* Background globe image provided by user */}
      <img
        src="/images/transform/cta-globe-banner.png"
        alt="Cognitive AI Globe"
        aria-hidden
        className="absolute inset-0 h-full w-full object-cover object-right lg:object-center pointer-events-none select-none"
      />

      {/* Subtle overlay on smaller screens for crisp text contrast */}
      <div
        className="absolute inset-0 bg-gradient-to-r from-[#000E1B]/90 via-[#000E1B]/40 to-transparent lg:hidden pointer-events-none"
      />

      {/* Content */}
      <div className="relative mx-auto w-full max-w-[1440px] px-6 lg:px-[70px]">
        <div className="flex max-w-[580px] flex-col items-start gap-4 sm:gap-5">
          <p className="text-[11.5px] font-bold uppercase tracking-[2.5px] text-[#8EA3BD]">
            THE COGNITIVE AI COMPANY
          </p>

          <h2 className="text-[34px] sm:text-[42px] lg:text-[46px] font-bold leading-[1.12] tracking-tight text-white">
            Turn intelligence into outcomes.
          </h2>

          <p className="text-[15px] sm:text-[15.5px] leading-[25px] text-[#A2B6CE] max-w-[500px]">
            Explore how Cognitive AI can create real value for your business.
          </p>

          <div className="pt-3">
            <button
              onClick={openAgent}
              className="group inline-flex items-center gap-2.5 rounded-full bg-white px-7 py-3.5 text-[14px] sm:text-[14.5px] font-semibold text-[#04101D] transition-all duration-300 hover:scale-[1.03] active:scale-95 cursor-pointer"
              style={{
                boxShadow: "0 0 24px 3px rgba(47, 115, 246, 0.75), 0 0 45px rgba(0, 210, 238, 0.35)",
              }}
            >
              <span>Discover Your AI Opportunities</span>
              <ArrowRight
                className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1"
                strokeWidth={2.2}
              />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

